import { useLocaleDirection } from "@/hooks/useLocaleDirection";
import { DirectionProvider } from "@radix-ui/react-direction";

export function LocaleDirectionProvider({ children }: { children: React.ReactNode }) {
    const dir = useLocaleDirection();
    return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}
